import React from 'react';
import DocumentUpload from '../../components/media/DocumentUpload';
import ShowDocumentGallery from '../../components/media/ShowRecords'; // new modular component for show docs

export default function Step2Temperament({ formData, dropdowns, onNext, onBack, onChange }) {
  const handleInput = (e) => {
    const { name, value } = e.target;
    const keys = name.split('.');

    if (keys.length === 2) {
      onChange({
        horseInfo: {
          ...formData.horseInfo,
          [keys[1]]: value
        }
      });
    } else {
      onChange({
        horseInfo: {
          ...formData.horseInfo,
          [name]: value
        }
      });
    }
  };

  const handleRegistrationChange = (e) => {
    const { name, value } = e.target;
    onChange({
      horseInfo: {
        ...formData.horseInfo,
        registration: {
          ...formData.horseInfo?.registration,
          [name.split('.')[1]]: value
        }
      }
    });
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold mb-4">Training, Temperament & Show History</h2>

      <div className="columns-md">
        <label className="block text-sm font-bold">Training Level</label>
        <select
          name="traininglevel"
          value={formData.horseInfo?.traininglevel || ''}
          onChange={handleInput}
          className="w-full border rounded px-3 py-2"
        >
          <option value="">Select</option>
          {dropdowns.trainingLevel?.map((level) => (
            <option key={level} value={level}>{level}</option>
          ))}
        </select>

        <label className="block text-sm font-bold">Temperament</label>
        <select
          name="temperament"
          value={formData.horseInfo?.temperament || ''}
          onChange={handleInput}
          className="w-full border rounded px-3 py-2"
        >
          <option value="">Select</option>
          {dropdowns.temperament?.map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-sm font-bold">Is the horse registered?</label>
        <select
          name="registration.registered"
          value={formData.horseInfo?.registration?.registered || ''}
          onChange={handleRegistrationChange}
          className="w-full border rounded px-3 py-2"
        >
          <option value="">Select</option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </div>

      {formData.horseInfo?.registration?.registered === 'true' && (
        <>
          <div>
            <label className="block text-sm font-bold">Registration Organization</label>
            <select
              name="registration.registryName"
              value={formData.horseInfo?.registration?.registryName || ''}
              onChange={handleRegistrationChange}
              className="w-full border rounded px-3 py-2"
            >
              <option value="">Select organization</option>
              {dropdowns?.registryName?.map((name) => (
                <option key={name} value={name}>{name}</option>
              ))}
            </select>
          </div>

          {formData.horseInfo?.registration?.registryName === 'Other' && (
            <div>
              <label className="block text-sm font-bold">Enter Registry Name</label>
              <input
                type="text"
                name="registration.registryNameOther"
                value={formData.horseInfo?.registration?.registryNameOther || ''}
                onChange={handleRegistrationChange}
                className="w-full border rounded px-3 py-2"
              />
            </div>
          )}
        </>
      )}

      <div>
        <label className="block text-sm font-bold">Horse History / Training Notes</label>
        <textarea
          name="history"
          value={formData.horseInfo?.history || ''}
          onChange={handleInput}
          className="w-full border rounded px-3 py-2 h-28"
          placeholder="Describe prior training, rider level, past use, etc."
        />
      </div>

      <div>
        <label className="block text-sm font-bold">Show / Competition Results</label>
        <textarea
          name="competitionResults"
          value={formData.horseInfo?.competitionResults || ''}
          onChange={handleInput}
          className="w-full border rounded px-3 py-2 h-28"
          placeholder="List placements, disciplines, dates, and levels of any shows or events."
        />
      </div>

      <div>
        <label className="block text-sm font-bold mb-2">Upload Show / Competition Documents</label>
        <DocumentUpload
          tag="show"
          onUploadComplete={(url, publicId) =>
            onChange({
              documents: [...(formData.documents || []), { url, public_id: publicId, tag: 'show' }]
            })
          }
        />
      </div>

      {formData.documents?.filter(doc => doc.tag === 'show').length > 0 && (
        <ShowDocumentGallery
          documents={formData.documents.filter(doc => doc.tag === 'show')}
          onRemove={(indexToRemove) => {
            const updatedDocs = formData.documents.filter((doc, idx) => !(doc.tag === 'show' && idx === indexToRemove));
            onChange({ documents: updatedDocs });
          }}
        />
      )}

      <div className="flex justify-between mt-8">
        <button onClick={onBack} className="bg-gray-300 text-black py-2 px-6 rounded">
          Back
        </button>
        <button onClick={onNext} className="bg-primary text-white py-2 px-6 rounded hover:bg-primary-dark">
          Next
        </button>
      </div>
    </div>
  );
}